export default __webpack_public_path__ + "static/media/saved-icon.b848b407.svg";